<template>
  <div id="app">
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style lang="stylus" type="text/stylus" rel="stylesheet/stylus">
</style>



// WEBPACK FOOTER //
// src/App.vue